module.exports = __webpack_public_path__ + "static/img/p5.f8d5e5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/p5.png
// module id = npQi
// module chunks = 15